import { RI001 } from './RI/RI001';
import { RI002 } from './RI/RI002';
import { RI003 } from './RI/RI003';
import { RI003O } from './RI/RI003O';
import { RI004 } from './RI/RI004';
import { RI003A } from './RI/RI003A';
import { RI004A } from './RI/RI004A';
import { RIIOTEVENTHUB } from './RI/RIIOTEVENTHUB';
import { RICONSUMERAPP } from './RI/RICONSUMERAPP';
import { RI005 } from './RI/RI005';
import { COMMON } from './RI/COMMON';
import { RI003AWS } from './RI/RI003AWS';
import { Day2Common } from './Day2Operations/Day2Common';
import { ProjectOnboarding } from './Day2Operations/ProjectOnboarding';
import { CloudOnboarding } from './Day2Operations/CloudOnboarding';
import { GithubOnboarding } from './Day2Operations/GithubOnboarding';
import { Ec2 } from './AWS/Ec2';
import { OracleRds } from './AWS/OracleRds';
import { S3Bucket } from './AWS/S3Bucket';
import { RI001A } from './RI/RI001A';

export const endPoints = {
    catalog: {
        get: '/api/static/lookups/1.0/catalog',
        allList: '/api/static/lookups/1.0/catalogs',
        recommendation: '/1.0/user/catalogs/recommendation',
    },
    user: {
        auth: '/user/auth',
    },
    employee: {
        listV2: 'api/employees/2.0/employee/list',
    },
    pgcsSql: {
        applications: 'api/app-registrations/3.0/all-app-profiles',
        subscriptionSearch: 'api/azure/lookups/1.0/subscription-search',
        environment: 'api/static/lookups/1.0/pgcs-environments',
        newEnvironment: 'api/static/lookups/2.0/environments',
        environmentRegion: 'api/static/lookups/1.0/pgcs-environment-regions',
        domains: 'api/static/lookups/.0/pgcs-domains',
        domainsV2: 'api/static/lookups/1.0/pgcs-domains',
        adOu: (domain) => `api/static/lookups/1.0/ad-organizational-units/${domain}/activedirectorypcms_ous`,
        resourceGroups: (region, subscriptionId) => `api/azure/lookups/1.0/rg/region/${region}/subscription/${subscriptionId}`,
        virtualNetwork: (region, subscriptionId) => `api/azure/lookups/1.0/vnet/region/${region}/subscription/${subscriptionId}`,
        virtualNetworkV2: (region, subscriptionId) => `api/azure/lookups/2.0/vnet/region/${region}/subscription/${subscriptionId}`,
        subNet: (region, vnetId) => `api/azure/lookups/1.0/manufacture-subnets?location=${region}&vnetId=${vnetId}`,
    },
    ssp: {
        dashboard: {
            sql: '/api/static/lookups/1.0/elastic-search/eiap-ece/sql',
            es: '/api/static/lookups/1.0/elastic-search/eiap-ece/dsl',
            applicationOnBoard: '/api/elastic/lookups/1.0/application-onboarded',
            provisionedResources: '/api/elastic/lookups/1.0/provisioned-resources',
            orderTrend: '/api/elastic/lookups/1.0/order-trend',
            aggregatedCount: '/api/elastic/lookups/1.0/aggregated-count',
            catalogs: '/api/static/lookups/1.0/Azure/cloudservices',
            services: 'dashboard-service.json',

            //       dashboardenhancementapi's
            orderTrendMock: '/dashboard-enhancement/orderTrend.json',
            metricApi: 'api/elastic/lookups/1.0/metrics',
            applicationOnBoarded: '/dashboard-enhancement/applicationsOnboarded.json',
            catalogsCount: '/dashboard-enhancement/catalogCounts.json',
            catalogsProvisioned: '/dashboard-enhancement/catalogsProvisioned.json',
            servicesByCatalog: '/dashboard-enhancement/servicesByCatalog.json',
            servicesByMonth: '/dashboard-enhancement/servicesByMonth.json',
            // servicesByCatalog: '/dashboard-enhancemnt/servicesByCatalog.json',
            solutionByMonth: '/dashboard-enhancement/solutionsByMonth.json',
            solutionsByCatalog: '/dashboard-enhancement/solutionsBycatalog.json',
            orderProcessingService: '/dashboard-enhancement/orderProcessingService.json',
            orderProcessingSolution: '/dashboard-enhancement/orderProcessingSolutions.json',
        },
        applicationDetails: '/api/cmdb/lookups/1.0/applications',
        vm: {
            appProfiles: '/api/app-registrations/2.0/provisioning/app-profiles',
            appProfileDetails: '/api/app-registrations/1.0/app-profiles',
            appTiers: '/api/app-registrations/1.0/app-tiers',
            appTiers_v2: '/api/static/lookups/1.0/app-tiers',
            azureManagedDisks: '/selfserviceprovisioning/vm/azure-managed-disks',
            costCalculation: '/selfserviceprovisioning/vm/cost-calculation',
            dataDisks: '/selfserviceprovisioning/vm/data-disks',
            environments: '/api/app-registrations/1.0/environments',
            environmentDetails: '/api/app-registrations/1.0/environment-details',
            environmentDetails_v2: '/api/app-registrations/2.0/environment-details',
            hoursOfOperation: '/selfserviceprovisioning/vm/hours-of-operation',
            linuxDiskConfigurations: '/selfserviceprovisioning/vm/linux-data-disk-config',
            windowsDiskConfigurations: '/selfserviceprovisioning/vm/windows-data-disk-config',
            defaultDataDisk: '/api/static/lookups/1.0/oel-data-disks',
            mandatoryTags: '/selfserviceprovisioning/vm/mandatory-tags',
            osTypes: '/selfserviceprovisioning/vm/ostypes',
            // osVersions: '/selfserviceprovisioning/vm/osversions',
            osVersions: 'selfserviceprovisioning/vm/marketplace-images',
            customMarketPlaceImages: 'api/azure/lookups/1.0/custom-images',
            customImages: 'api/azure/lookups/2.0/custom-images',
            powerBrokerRole: '/selfserviceprovisioning/vm/powerbrokerrole',
            regions: '/api/app-registrations/1.0/regions',
            resourceGroupTags: '/selfserviceprovisioning/vm/resourcegroup/',
            timezones: '/selfserviceprovisioning/vm/os-timezones',
            types: '/selfserviceprovisioning/vm/vmtypes',
            vmTypes: 'api/azure/lookups/1.0/vmsizes',
            submitOrder: '/selfserviceprovisioning/vm/submit-order',
            disasterRecoveryOptions: '/selfserviceprovisioning/vm/disaster-recovery-options',
            azureRecoveryVault: '/selfserviceprovisioning/vm/azure-revovery-vault',
            hCode: 'api/cmdb/lookups/1.0/projects',
            budgetCode: 'api/static/lookups/1.0/validate/budget-code',
            adOu: 'api/static/lookups/1.0/ad-organizational-units',
            sector: 'api/static/lookups/1.0/sectors',
            adDomain: 'api/static/lookups/1.0/ad-domains',
            billingEntities: 'api/static/lookups/1.0/billing-entities',
            sam: 'api/idm/lookups/samaccounts',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/vm',
            serverName: 'api/cmdb/lookups/1.0/servers',
            sapDataDisks: 'api/static/lookups/1.0/sap-pgt-data-disks',
            sapSolution: 'api/static/lookups/1.0/sap-solution',
            dbSize: '/pgt-hana-dbsize.json',
            pgtHanaDiskConfig: '/api/static/lookups/1.0/sap-pgt-hana-data-disks', //    '/pgt-hana-vmtype.json' ,
            unixGroupValidation: 'api/ri/order/myidm/1.0/validate/sam-unix-details',
            sapEnvironment: 'api/static/lookups/1.0/sap-environments',
            customBuildVmData: 'api/static/lookups/1.0/custom-build-types',
            sapFeaturesList: 'api/static/lookups/1.0/sap-features-list',
            sapSubscriptionsList: (environment) => `api/static/lookups/1.0/sap-subscription-list?environment=${environment}`,
            applicationSecurityGroup: (subscriptionId, resourceGroup) =>
                `api/azure/lookups/pgt-sap-solutions/1.0/subscription/${subscriptionId}/resource-group/${resourceGroup}/application-security-groups`,
            pgtSapVmType: 'api/azure/lookups/pgt-sap-solutions/1.0/vm-sizes',
            pgtSapBinaryConfig: 'api/static/lookups/1.0/pgt-sap-binary-configuration',
        },
        couchbase: {
            dbVersions: 'api/static/lookups/1.0/couchbase/dbversions',
            // nodeCount: 'couchbaseNodeCount.json',
            defaults: 'api/static/lookups/1.0/catalog/COUCHBASEDB/defaults',
            serviceMappings: 'api/static/lookups/1.0/couchbase/servicemapping',
            bucketTypes: 'api/static/lookups/1.0/couchbase/buckettypes',
        },
        aks: {
            departments: 'api/eip/lookups/2.0/departments/AKS',
            businessUnit: 'api/eip/lookups/1.0/business-units',
            cluster: 'api/eip/lookups/1.0/clusters/AKS',
            catalogSize: 'api/eip/lookups/1.0/catalog-sizes',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/aksns',
            validate: 'api/eip/lookups/1.0/validate',
            adGroup: 'api/eip/lookups/1.0/all-adgroups',
            validateADGroup: 'api/eip/lookups/1.0/validate-adgroup-name',
            network: 'api/eip/lookups/1.0/clusters/network',
            aksKeyvaultName: 'api/ri/resource/name/1.0/preview-resource-name',
            // EDAP AKS Namespace endpoints
            requestType: 'api/static/lookups/1.0/edap-request-details',
            clusterDetails: (region) => `1.0/edap-aks-cluster-details?region=${region}`,
            namespaceName: 'api/ri/resource/name/1.0/edap-aks-namespace',
            nodePool: (subscriptionId, resourceGroup, clusterName) =>
                `api/azure/lookups/1.0/edap-aks/node-pool-details?subscriptionId=${subscriptionId}&resourceGroup=${resourceGroup}&clusterName=${clusterName}`,
        },
        storage: {
            dataClassification: 'api/static/lookups/1.0/application-data-classification',
            redundancy: 'api/static/lookups/1.0/storage-replication',
            premiumAccountType: 'api/static/lookups/1.0/storage-premium-account-type',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/paas/azure-storage',
            accountName: 'api/azure/lookups/1.0/validate-storage-account-name',
        },
        oel: {
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/iaas/oracle',
        },
        oracle: {
            oracleDataDisks: 'api/static/lookups/1.0/oracle-data-disks',
            oracleDataDisksV2: 'api/static/lookups/2.0/private-cloud-oracle-data-disks',
            oracleQuickConfig: 'selfserviceprovisioning/vm/1.0/config/iaas/oracle',
            dbCharacterSet: 'api/static/lookups/1.0/oracle-database-character-sets',
            dbNationalCharacterSet: 'api/static/lookups/1.0/oracle-national-character-sets',
            oracleId: 'api/idm/lookups/oracleaccounts',
            catalogSize: 'api/azure/lookups/1.0/nvme-catalog-size',
            nvmeyesVmType: 'api/azure/lookups/1.0/nvme-vmtype',
            expDBvalidation: 'api/azure/lookups/1.0/validate/nvme-db-size',
        },
        sqlPaas: {
            serverCollation: 'api/azure/lookups/sql/collations',
            deploymentModel: 'api/azure/lookups/sql/deploymentmodels',
            serviceTiers: 'api/azure/lookups/sql/servicetiers',
            capabilities: 'api/azure/lookups/sql/capabilities',
            storageSizes: 'api/azure/lookups/sql/max-storagesizes',
            storageSizesV2: 'api/azure/lookups/2.0/sql/max-storagesizes',
            logicalHosts: 'api/azure/lookups/sql/logical-servers',
            elasticPoolNames: 'api/azure/lookups/1.0/elastic-pool',
            sqlDatabases: 'api/azure/lookups/sql/logical-databases',
            checkLogicalHostExists: 'api/azure/lookups/sql/validate-server',
            costCalculation: 'api/azure/lookups/sql/cost-calculation',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/sqlpaas',
            sqlserviceAccountNameApi: 'api/ri/resource/name/1.0/service-account/validate',
        },
        sqlIaas: {
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/iaas/sql',
            sqlVersions: '/api/static/lookups/1.0/sql-versions',
            sqlService: '/api/static/lookups/1.0/sql-services',
            sqlDataDisks: 'api/static/lookups/1.0/sql-data-disks',
            adOU: 'api/static/lookups/1.0/ad-organizational-units',
            resourceGroup: 'api/azure/lookups/1.0/resourceGroups',
            vnetDR: 'api/azure/lookups/vnet/name',
            subnetDR: 'api/azure/lookups/2.0/subnets',
            locationPair: 'api/azure/lookups/1.0/location-pair',
            gmsaServiceAccount: 'api/ri/order/myidm/1.0/gmsa/validate/service-account',
            gmsaComputerGroup: 'api/ri/order/myidm/1.0/gmsa/validate/computer-group',
        },
        nsg: {
            submitRule: '/api/nsg/automation/ansible/1.0/rule',
            allList: '/catalog.json',
        },
        adGroup: 'api/azure/lookups/1.0/ad-groups',
        sku: {
            types: 'api/azure/lookups/1.0/landingzone-reference-types',
            skuList: 'api/azure/lookups/1.0/landingzone-reference',
            skuListVmTypes: 'api/azure/lookups/1.0/landingzone-reference-vmsizes',
            vmTypeUpdate: 'api/azure/lookups/1.0/vmskus-reference-update',
        },
        keyVault: {
            keyVaultName: '/api/azure/lookups/1.0/validate-key-vault-name',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/key-vault',
            costCalculation: '/keyVaultCostSummary.json',
        },
        alb: {
            sessionPersistence: 'api/azure/lookups/1.0/session-persistance',
            protocols: 'api/azure/lookups/1.0/protocols',
            availZones: 'api/azure/lookups/1.0/alb/availability-zones',
            virtualMachine: 'api/azure/lookups/1.0/virtual-machines',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/load-balancer',
        },
        kafka: {
            departments: 'api/eip/lookups/2.0/departments/Kafka',
            cluster: 'api/eip/lookups/1.0/clusters/Kafka',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/kafka',
            validate: 'api/eip/lookups/1.0/validate-kafka-topic',
            validateNewLdapGrp: 'api/ri/order/myidm/1.0/check-idx-group',
            validateBgLdapGrp: 'api/ri/order/myidm/1.0/validate-idx-group',
            retention: 'kafka-retention-periods.json',
            serviceAccountApi: 'api/day2/order/service-accounts/validate',
            serviceAccountYesValidation: 'api/ri/resource/name/1.0/service-account/validate',
            serviceAccountNoValidation: 'api/day2/1.0/internal/validate-service-account',
            ldapGroup: 'api/static/lookups/1.0/kafka/ldap-group',
        },
        privateEndpoint: {
            applications: 'api/app-registrations/3.0/all-app-profiles',
            environments: 'api/static/lookups/1.0/environments',
            regions: 'api/azure/lookups/locations',
            dataClassification: 'api/static/lookups/1.0/application-data-classification',
            resource: 'api/azure/lookups/private-endpoint/1.0/location/region/subscription/subscriptionId/resources',
            resourceType: 'api/azure/lookups/private-endpoint/1.0/resource-types',
            endpointType: 'api/azure/lookups/private-endpoint/1.0/private-endpoint-type',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/azure-private-endpoint',
            validatePrivateEndPoint: 'api/azure/lookups/private-endpoint/1.0/validate-private-endpoint',
            dns: 'api/azure/lookups/private-endpoint/1.0/dns',
            targetSubResource: 'api/azure/lookups/private-endpoint/1.0/location/region/subscription/subscriptionId/resources',
            modifiedSubscription: 'api/azure/lookups/private-endpoint/1.0/modified-subscriptions',
            resources: '/1.0/location/region/subscription/subscriptionId/resources',
            validate: 'api/azure/lookups/private-endpoint/1.0/location/region/subscription/subscriptionId/databricks/value/validate-databricks-name',
        },
        privateEndpointV2: {
            applications: 'api/app-registrations/3.0/all-app-profiles',
            environments: 'api/static/lookups/1.0/environments',
            distributionListByCatalogCode: (catalogCode) => `api/static/lookups/1.0/distribution-lists/catalogcode/${catalogCode}`,
            resourceType: 'private-endpoint/1.0/resource-types',
            resources: 'private-endpoint/1.0/resource-details',
            resourcesV2: 'private-endpoint/2.0/resource-details',
            resourcesSubType: 'private-endpoint/1.0/sub-resource-types',
            validate: 'private-endpoint/1.0/internal/validate',
            preview: 'private-endpoint/1.0/preview',
            costCalculation: 'api/costs/1.0/cost-calculation',
            order: 'PE/order.json',
            submit: 'private-endpoint/order-submit',
            submitV2: 'private-endpoint/2.0/order-submit',
            reSubmit: 'private-endpoint/order-resubmit',
            reSubmitV2: 'private-endpoint/2.0/order-resubmit',
        },
        nsgAutomationRules: {
            applications: 'api/app-registrations/3.0/all-app-profiles',
            environments: 'api/static/lookups/1.0/environments',
            resourceType: 'private-endpoint/1.0/resource-types',
            resources: 'private-endpoint/1.0/resource-details',
            resourcesSubType: 'private-endpoint/1.0/sub-resource-types',
            validate: 'private-endpoint/1.0/internal/validate',
            preview: '/nsg-automation-rules/1.0/preview', // nsgPreview.json
            costCalculation: 'api/costs/1.0/cost-calculation',
            order: 'PE/order.json',
            submit: 'nsg-automation-rules/1.0/order',
            reSubmit: 'nsg-automation-rules/1.0/order',
            sapComponents: 'api/static/lookups/1.0/sap-components',
            nsgDetailsByName: (name) => `api/azure/lookups/1.0/nsg-details/name/${name}`,
            nsgDetails: 'api/azure/lookups/1.0/nsg-details',
        },
        eventHub: {
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/azure-eventhub',
            eventHubLookup: 'api/azure/lookups/1.0/event-hub',
            validateNamespace: 'api/azure/lookups/1.0/validate-event-hub',
            throughputUnits: 'api/azure/lookups/1.0/event-hub/throughput-units',
            processingUnits: 'api/azure/lookups/1.0/event-hub/processing-units',
        },
        day2Operation: {
            // projects: '/day2-projects.json',
            projects: '/api/static/lookups/projects',
            serverNames: '/day2-server-names.json',
            modificationTypes: '/day2-modification-types.json',
            configureNewSku: '/day2-configure-new-sku.json',
            environmentDetails: '/day2-env-details.json',
            quickConfig: '/day2-config.json',
            sku: '/day2-sku.json',
            iops: '/day2-iops.json',
            ram: '/day2-ram.json',
            storageType: '/day2-storage-type.json',
            diskSku: '/day2-disk-sku.json',
        },
        day2OperationPass: {
            modificationTypes: '/day2pass-modification-types.json',
            storageAccounts: '/day2pass-storage-ac.json',
            capabilities: '/day2pass-capabilities.json',
            modifyService: '/day2pass-modify-service.json',
            tier: '/day2pass-tier.json',
            redundancy: '/day2pass-redundancy.json',
            targetSub: '/day2pass-target-sub.json',
            resourceGrp: '/day2pass-resource-grp.json',
            quickConfig: '/day2paas-config.json',
        },
        eipStack: {
            ipAddress: 'api/eip/lookups/1.0/clusters/ip',
            catalogSize: 'api/static/lookups/1.0/cle/catalog-sizes',
        },
        azureDataFactory: {
            version: 'api/static/lookups/1.0/adf-versions',
            quickConfig: 'selfserviceprovisioning/vm/1.0/config/paas/adf',
            validateAdfName: 'api/azure/lookups/1.0/validate-adf-name',
        },
        privateCloud: {
            clusterMapping: 'api/static/lookups/v2/1.0/private-cloud/cluster-mapping',
            clusterDetails: 'api/static/lookups/v2/1.0/private-cloud/cluster-details',
            osTemplate: 'api/static/lookups/1.0/private-cloud/os-templates/windows',
            osTemplateLinux: 'api/static/lookups/1.0/private-cloud/os-templates/linux',
        },
        submitOrder: '/orders',
        costCalculation: 'api/costs/1.0/cost-calculation',
    },
    cart: {
        getCartCount: 'api/cart/1.0/cart/item/count',
        getCart: 'api/cart/1.0/cart', // /cart.json or api/cart/1.0/cart
        getCartItem: 'api/cart/1.0/cart/item', // /cartItem.json or api/cart/1.0/cart/item/<cartItemId>
        addItem: 'api/cart/1.0/cart/item', // api/cart/1.0/cart/item/<cartItemId>
        submitOrder: 'api/cart/1.0/cart/submit',
        deleteCartItemByApplication: 'api/cart/1.0/cart/application/items',
    },
    appProfile: {
        allAppProfiles: 'api/app-registrations/1.0/all-app-profiles',
        myAppProfiles: 'api/app-registrations/1.0/app-profiles',
        appProfileById: 'api/app-registrations/1.0/app-profiles',
        businessCI: 'api/cmdb/lookups/1.0/applications',
        appOwner: 'api/employees/2.0/employee/list',
        submitAppProfile: 'api/app-registrations/1.0/app-profile',
    },

    landingZones: {
        subscription: 'api/azure/lookups/subscriptions',
        resourceGroup: 'api/azure/lookups/resourceGroups',
        Vnet: 'api/azure/lookups/vnet',
        Subnet: 'api/azure/lookups/1.0/subnets',
        NetSecGroup: 'api/azure/lookups/nsg',
        AppSecGroup: 'api/azure/lookups/asg',
        ProxProfileGroup: 'api/azure/lookups/1.0/proximity-placement-groups',
        availabilitySet: 'api/azure/lookups/1.0/availability-sets',
        availabilityZone: 'api/azure/lookups/1.0/availability-zones',
        cloudProvider: 'api/static/lookups/1.0/cloudproviders',
        cloudService: 'api/static/lookups/1.0',
        createLandingZone: 'api/app-registrations/2.0/landing-zone',
        editLandingZone: 'api/app-registrations/1.0/landing-zone',
        approveDraftLZ: 'api/app-registrations/1.0/approve-draft-landing-zone',
        environments: 'api/static/lookups/1.0/environments',
        eipEnvironments: 'api/eip/lookups/1.0/environments',
        appTier: 'api/static/lookups/1.0/applicationtiers',
        regions: 'api/azure/lookups/locations',
        eipRegions: 'api/eip/lookups/1.0/regions',
        geoRecoveryRegion: 'api/azure/lookups/1.0/location-pair',
        landingZones: 'api/app-registrations/1.0/landing-zones',
        landingZone: 'api/app-registrations/1.0/landing-zone',
        replication: 'api/static/lookups/1.0/storage-replication',
        departments: 'api/eip/lookups/2.0/departments',
        eipDepartments: 'api/eip/lookups/1.0/catalog-departments',
        dataClassification: 'api/static/lookups/1.0/application-data-classification',
        businessUnit: 'api/eip/lookups/1.0/business-units',
        cluster: 'api/eip/lookups/1.0/clusters',
        sku: '/azure-alb-sku.json',
        type: '/azure-alb-type.json',
        privateEndpoint: {
            endPointType: 'api/azure/lookups/private-endpoint/1.0/private-endpoint-type',
            subscription: 'api/azure/lookups/private-endpoint/1.0/subscriptions',
            resourceGroup: 'api/azure/lookups/private-endpoint/1.0/location/{region}/subscription/{subscriptionId}/resource-groups',
            vNet: 'api/azure/lookups/private-endpoint/1.0/location/{region}/subscription/{subscriptionId}/vnet',
            subnet: 'api/azure/lookups/private-endpoint/1.0/subnets',
        },
        eipStack: {
            components: 'api/static/lookups/1.0/cloudprovider/{cloudprovider}/catalog/{cloudservice}',
            connection: 'api/static/lookups/1.0/connections',
            costCalculation: '/eiap-costCalcuation.json',
            // components: 'eip-landingzone-components.json',
        },
    },
    order: {
        myOrders: '/my-orders',
        allOrders: '/all-orders',
        getOrder: '/orders/details/{orderId}',
        getCatalogs: '/order/catalogs/{orderId}',
        getComponentLogs: '/orders/component/logs',
        getLogs: '/orders/logs/{orderId}',
        getLogsUpdated: '/orders/logs/{orderId}/{subOrderId}',
        cancelOrder: '/cancelorder',
        orderDetails: '/orders',
        orderDetailsV2: '2.0/orders',
        changeManger: '/order/change-manager',
        mangerList: '/api/employees/1.0/managers',
        orderStatus: '/order-statuses',
        saveOrder: '/order/{orderId}/catalog/{catalogServiceId}',
        allAppProfiles: '/api/app-registrations/2.0/all-app-profiles',
    },
    approvals: {
        myApprovals: '/my-approvals',
        approveOrRejectOrders: '/orders/manage',
        changeCostCenter: '/approver/order',
    },

    helpDocuments: {
        getDocuments: '/api/azure/lookups/1.0/documents',
        downloadDoc: '/api/azure/lookups/1.0/download-attachment',
    },
    general: {
        support: 'mailto:DL - Global DevX Operations?subject=Query on DevX Services:',
        help: '/help',
        feedback:
            'https://forms.office.com/Pages/ResponsePage.aspx?id=lTLMQg7NnES5jlzltWDB083kw2uYiVRKpnB6VMbU87FUQUk0TVdXVDhaTzZESU1ZWllNUTYyVDBTUC4u&wdLOR=cCD537E5B-2024-4780-B8D1-40098B305781',
        welcomepdf: 'https://pepsico.sharepoint.com/:w:/t/CTO-DigitalServices/EYYTlpq9e7RFrjPRNo5BZwIBOUJAHU4qZYb3heO1j-b8xg?e=dceTpP',
    },

    ssoOkta: {
        applicationCI: 'api/cmdb/lookups/1.0/business-application/services',
        businessApp: 'api/cmdb/lookups/1.0/business-application',
        environments: 'api/static/lookups/v2/1.0/environments',
        sectors: 'api/static/lookups/1.0/sectors',
        applicationType: 'api/static/lookups/1.0/application-types',
        dataClassification: 'api/static/lookups/1.0/application-data-classification',
        appShortNameValidation: 'api/ri/resource/name/1.0/app-short-name/availability',
        appShortName: 'api/ri/resource/name/1.0/app-short-name/available',
        nameIdFormat: 'api/static/lookups/1.0/name-id-formats',
        accessRestriction: 'api/static/lookups/1.0/access-restrcitions',
        appOwnerSso: 'api/employees/3.0/employee/list',
        applicationOwner: (businessApplication) => `api/order/snow/1.0/${businessApplication}/it-owner`,
        appClientID: (id, environment, requestType) => `api/order/ssookta/metadata/applicationId/${id}/environment/${environment}/signOnMode/${requestType}`,
        appClientName: (environment, signOnMode, businessApplication) =>
            `api/order/ssookta/api/sso/apps?environment=${environment}&signOnMode=${encodeURIComponent(signOnMode)}&businessAppName=${encodeURIComponent(
                businessApplication
            )}`,
        applicationLogo: 'api/azure/lookups/1.0/download-attachment',
        Jwt: {
            submitOrder: 'api/day2/1.0/internal/order/sso-okta/submit',
            saveChangesInOrder: 'api/day2/1.0/internal/order/sso-okta',
            modifySubmitOrder: 'api/day2/1.0/internal/order/modify-sso-okta/submit',
            modifySaveChangesInOrder: 'api/day2/1.0/internal/order/modify-sso-okta',
            idxAttribute: 'api/day2/1.0/sso-okta/vaidate/idx-attribute',
            idxAttributeShortName: (idxShortName, environment) =>
                `api/day2/1.0/sso-okta/idx-attribute/exists/name/pepapp${idxShortName}status/environment/${environment}`,
            idxAttributeShortNameJwt: `api/day2/1.0/sso-okta/idx-attribute/exists/name`,
        },
    },
    onboardAppService: {
        environments: 'api/static/lookups/1.0/environments',
        sectors: 'api/static/lookups/1.0/sectors',
        businessCriticality: 'api/static/lookups/1.0/business-criticality',
        Jwt: {
            submitOrder: 'api/order/snow/1.0/application-service-creation',
        },
    },
    securityTool: {
        applicationCI: 'api/app-registrations/3.0/all-app-profiles',
        environments: 'api/static/lookups/1.0/environments',
        sectors: 'api/static/lookups/1.0/sectors',
        applicationOwner: 'api/employees/3.0/employee/list',
        member: 'api/employees/2.0/employee/list',
        Jwt: {
            teamName: 'api/day2/1.0/internal/order/security-tool/team-name/sector',
            createOrder: 'api/day2/1.0/internal/order/security-tool/submit',
            editOrder: 'api/day2/1.0/internal/order/security-tool',
        },
    },
    day2Operation: {
        Day2Common,
        ProjectOnboarding,
        CloudOnboarding,
        GithubOnboarding,
    },
    aws: {
        Ec2,
        OracleRds,
        S3Bucket,
        generateEksNamespace: 'api/ri/resource/name/aws/1.0/generate/eks-namespace',
        generateResourceName: 'api/ri/resource/name/aws/1.0/generate-resource-name',
        awsSubmitAPI: '1.0/aws-cloud-onboarding/order',
        awsAcctVending: '1.0/aws-account-vending/order',
        internalUrlOnboardingSubmit: '1.0/aws-internal-url/onboarding/order',
        externalUrlOnboardingSubmit: '1.0/aws-external-url/onboarding/order',
        csaApproval: 'api/azure/lookups/1.0/csa-members',
        acctVendingPreview: '/1.0/aws-account-vending/preview',
        acctVendingSubmitForApproval: '1.0/aws-account-vending/submit-approval',
        validateAwsAccountName: 'api/ri/resource/name/aws/1.0/validate/account-name',
        validateAwsOUName: 'api/ri/resource/name/aws/1.0/validate/ou-name',
        validateAppUrl: 'api/firewall/1.0/hostname/check',
        lookups: {
            targets: (region, accountId) => `api/aws/lookups/1.0/aws/ec2-instances/region/${region}/account/${accountId}`,
            targetTypes: 'api/aws/lookups/1.0/aws/load_balancer_target_groups_instance_types',
            targetIPAddress: 'api/aws/lookups/1.0/aws/ip-address/validate',
            targetTypesNLB: 'api/aws/lookups/1.0/aws/nlb_lb_tg_instance_types',
            targetGrpNameNlbArn: 'api/aws/lookups/1.0/aws/load-balancer-target-groups',
            loadBalancerTypes: 'api/aws/lookups/1.0/aws/load_balancer_types',
            listenerProtocols: 'api/aws/lookups/1.0/aws/load_balancer_listener_protocols',
            listenerProtocolNLB: 'api/aws/lookups/1.0/aws/network_load_balancer_listener_protocols',
            tableClass: 'api/aws/lookups/1.0/dynamodb/table-class',
            sectorV2: 'api/static/lookups/v2/1.0/internal/aws-sectors',
            departmentV2: (sector) => `api/static/lookups/v2/1.0/internal/aws-sectors/${sector}`,
            region: 'api/aws/lookups/1.0/aws-regions',
            applicationRegionV2: '/api/static/lookups/v2/1.0/aws-application-regions',
            sqlDataDisk: (databaseSize, environment) =>
                `api/aws/lookups/1.0/aws/sql-mandatory-data-disks?databaseSize=${databaseSize}&environment=${environment}`,
            oracleDataDisk: (databaseSize, environment) =>
                `api/aws/lookups/1.0/aws/oracle-mandatory-data-disks?databaseSize=${databaseSize}&environment=${environment}`,
            environment: 'api/static/lookups/1.0/environments',
            cloudType: 'api/static/lookups/1.0/cloud-types',
            onboardingCategory: 'api/static/lookups/1.0/onboarding-categories',
            businessSponser: 'api/cmdb/lookups/1.0/businessOwner',
            awsOrgUnit: 'api/aws/lookups/1.0/aws-ou-mappings',
            awsPrivilegedAdGroup: (adGroupSearchTerm) => `api/aws/lookups/1.0/identity-center/ad-groups?adGroupSearchTerm=${adGroupSearchTerm}`,
            awsEksPrivilegedAdGroup: (adGroupSearchTerm) => `api/aws/lookups/1.0/eks/ad-groups?adGroupSearchTerm=${adGroupSearchTerm}`,
            awsValidateAdGroup: (adGroupName) => `api/aws/lookups/1.0/validate/identity-center/ad-group?adGroupName=${adGroupName}`,
            awsAccountName: 'api/ri/resource/name/aws/1.0/preview/generate-resource-name',
            awsBusinessCategory: 'api/aws/lookups/1.0/aws-business-category',
            albNameInternal: 'api/aws/lookups/1.0/aws/load_balancer_names',
            albNameExternal: (region, applicationRegion, environment, sector) =>
                `api/aws/lookups/1.0/external-url-alb?region=${region}&applicationRegion=${applicationRegion}&environment=${environment}&sector=${sector}`,
            albNlbArn: 'api/aws/lookups/1.0/aws/load_balancer_urn',
            trafficTypes: 'api/static/lookups/aws/1.0/external-url-onboard-traffic-types',
            internalNlbDnsAndIps: 'api/aws/lookups/1.0/aws/internal-nlb/dns-and-ips',
            externalNlbDetails: (region) => `api/static/lookups/v2/1.0/external-nlb-details/${region}`,
            eksClusterDetails: 'api/static/lookups/v2/1.0/eks-clusters-properties',
            eksSize: (environment) => `api/eip/lookups/1.0/catalog-sizes?catalogName=EKS&environment=${environment}`,
            eksSector: (sector) => `api/static/lookups/v2/1.0/internal/eks-sectors/${sector}`,
            eksProgram: 'api/static/lookups/v2/1.0/eks/program',
            acctVendingLandingZone: 'api/static/lookups/v2/1.0/aws-landing-zone?includeAccountInformation=false',
            accVendingRegion: 'api/static/lookups/v2/1.0/aws-region',
            validateSharedNetworkAccountName: (sharedNetworkAccountName) => `api/aws/lookups/1.0/live/aws-account/by-name/${sharedNetworkAccountName}`,
            lexCreationMethod: 'api/static/lookups/1.0/aws-lex-bot-creation-methods',
            lexLocaleID: 'api/static/lookups/1.0/aws-lex-bot-locale',
            lambdaArchitecture: 'api/static/lookups/aws/1.0/lambda-architectures',
            lambdaMemorySize: 'api/static/lookups/aws/1.0/memory-configurations',
            lambdaRuntime: 'api/static/lookups/aws/1.0/runtime-environments',
            lambdaHandler: 'api/static/lookups/aws/1.0/lambda-handlers',
            lambdaVpcConnectivityTypes: 'api/static/lookups/aws/1.0/vpc-connectivity-types',
            lambdaAdoProjects: (searchTerm) => `api/project/integration/order/search/project?searchTerm=${searchTerm}`,
            lambdaAdoProjectOrg: (projectName) => `api/project/integration/1.0/ado/project-org/${projectName}`,
            lambdaRepositories: (adoOrganization, adoProjectName) =>
                `api/github/1.0/ado/repositories?adoOrganization=${adoOrganization}&adoProjectName=${adoProjectName}`,
            lambdaDefaultBranch: 'api/github/1.0/ado/repositories/branches',
            lambdaAvailableRoles: (accountID, region) => `api/aws/lookups/1.0/iam-execution-roles/accountId/${accountID}/region/${region}`,
            lexVoiceID: 'api/static/lookups/1.0/aws-lex-bot-voice-id',
            sqlRdsEngine: 'api/aws/lookups/1.0/aws-rds-engines?rdsEngineType=mysql-rds',
            dbCharacterSet: (databaseType) => `api/static/lookups/1.0/character-sets?databaseType=${databaseType}`,
            collations: (databaseType) => `api/static/lookups/1.0/collations?databaseType=${databaseType}`,
            snsMessageRetentionPeriod: 'api/static/lookups/1.0/aws-sns-message-retention-period',
            snsDeduplication: 'api/static/lookups/1.0/aws-sns-deduplication',
            snsSubscriptions: 'api/static/lookups/1.0/aws-sns-subscriptions',
            vpcDetails: 'api/aws/lookups/1.0/vpc-details',
            sqsQueueTypes: 'api/static/lookups/aws/1.0/sqs-queue-types',
            departments: 'api/eip/lookups/1.0/aws-kafka-cluster/departments',
            kafkaCluster: 'api/eip/lookups/1.0/aws-kafka-clusters',
            redisDeploymentTypes: 'api/static/lookups/v2/1.0/aws-redis-deployment-types',
            engineVersions: 'api/static/lookups/aws/1.0/documentdb/engine-versions',
            secondaryRegions: 'api/static/lookups/aws/1.0/documentdb/global-cluster-secondary-regions',
            instanceClass: 'api/static/lookups/aws/1.0/documentdb/global-cluster-instance-classes',
            numberOfInstances: 'api/static/lookups/aws/1.0/documentdb/instance-configuration-limits',
            elasticClusterConfigLimits: 'api/static/lookups/aws/1.0/documentdb/elastic-cluster-configuration-limits',
            storageLimits: 'api/static/lookups/aws/1.0/documentdb/storage-limits-by-engine-version',
            clusterType: 'api/static/lookups/aws/1.0/documentdb/cluster-types',
            applicationServiceMicroservices: (applicationServiceName) =>
                `api/cmdb/lookups/1.0/application-service/microservices?applicationServiceName=${encodeURIComponent(applicationServiceName || '')}`,
        },
    },
    riServices: {
        COMMON,
        RI001,
        RI002,
        RI003,
        RI003O,
        RI003A,
        RI003AWS,
        RI004,
        RI004A,
        RIIOTEVENTHUB,
        RICONSUMERAPP,
        RI005,
        RI001A,
        order: {
            // getOrderLogCatalogs: 'api/order/v2/1.0/order/catalogs/{orderId}',
            getOrderLogCatalogs: 'api/order/v2/internal/1.0/order/catalogs/{orderId}',
        },
        downloadApplyOutput: 'api/order/v2/1.0/internal/order',
        approval: {
            orderDetails: 'api/order/v2/1.0/cmp/order',

            // orderDetails: 'project-onboarding-approval-details.json',
        },
        Jwt: {
            // orders
            allOrders: 'api/order/v2/1.0/all-orders',
            myOrders: 'api/order/v2/1.0/my-orders',
            orderDetails: 'api/order/v2/1.0/cmp/order',
            orderDetailsV2: 'api/order/v2/2.0/cmp/order',
            orderDetailsV3: 'api/order/v2/approval/orders',
            changeManger: 'api/order/v2/1.0/order/change-manager',
            cancelOrder: 'api/order/v2/1.0/cmp/cancelorder', //    api/order/v2/1.0/cancelorder
            getOrderLogDetails: 'api/order/v2/1.0/orders/logs',

            // approvals
            myApprovals: 'api/order/v2/1.0/my-approvals',
            approve: 'api/order/v2/1.0/cmp/orders/approve-order', //   api/order/v2/1.0/orders/approve-order
            reject: 'api/order/v2/1.0/cmp/orders/reject-order', //  api/order/v2/1.0/orders/reject-order
            returnToUser: 'api/order/v2/1.0/cmp/orders/return-to-user',
            costCenter: 'api/order/v2/approver/order',

            // provisioning
            catalogs: 'api/ri-metadata-lookups/reference-implementation/v1/list',
            architecture: 'api/ri-metadata-lookups/reference-implementation/v1/{rid}/architecture',
            // internal
            catalogsInternal: 'api/ri-metadata-lookups/reference-implementation/v1/internal/list',
        },
    },
    inventoryReport: {
        catalogTypes: '/api/inventory/report/1.0/inventory-catalogs-types',
        catalogTypesV2: '/api/inventory/report/2.0/inventory-catalog-types',
        catalogDetails: (catalogServiceCode, cloudProvider) =>
            `/api/inventory/report/1.0/inventory-catalog-metadata?catalogServiceCode=${catalogServiceCode}&cloudProvider=${cloudProvider}`,
        listAks: '/api/inventory/report/1.0/inventory-report',
        downloadExcel: '/api/inventory/report/1.0/export-inventory-report',
    },
    myIdm: {
        groupCategories: 'api/static/lookups/1.0/group-categories',
        groupSubCategories: 'api/static/lookups/1.0/group-sub-categories',
        domainTypes: 'api/static/lookups/1.0/domain-types',
        modifyRequestTypes: 'api/static/lookups/1.0/modify-request-types',
        sectors: 'api/static/lookups/1.0/sectors',
        isexitAdGrp: '/myidm/nonexistadgrp.json',
        AdGroupType: '/myidm/adGroupsType.json',
        applicationNameApi: 'api/cmdb/lookups/1.0/business-application/services',
        adGroupApi: 'api/ri/order/myidm/1.0/all-adgroups',
        adGroupSearchApi: (search, domain) => `api/ri/order/myidm/1.0/adgroups?search=${search}&domain=${domain}`,
        adGroupMembersApi: 'api/ri/order/myidm/1.0/group-membership', //     /myidm/adGroupsMembers.json
        adGroupMembersApiV2: 'api/ri/order/myidm/2.0/group-membership', //     /myidm/adGroupsMembers.json
        adGroupIsUniversalApi: 'api/ri/order/myidm/1.0/validate/universal-group', //      /myidm/adgrp-isUniversal.json
        isCrossDomainUser: 'api/ri/order/myidm/1.0/validate/cross-domain-user', //    /myidm/adgrp-crossdomainUser.json
        mypamsafe: 'api/ri/resource/name/1.0/privileged-addmember/validate', // '/api/ri/resource/name/1.0/privileged-addmember/validate'     ///myidm/getmypamsafe.json
        myIdmCost: '/myidm/cad-grpCostRes.json',
        adGroupDetailsApi: 'api/eip/lookups/1.0/adgroups-details',
        groupTypes: 'api/static/lookups/1.0/members-group-type',
        // ldapGroupApi: '/myidm/ldap-group.json',
        ldapGroupApi: 'api/ri/order/myidm/1.0/ldap-groups',
        ldapGroupApiEmpty: '/myidm/ladp-group-empty.json', // for testing
        // ldapGroupMembersApi: '/myidm/ldap-group-members.json',
        ldapGroupMembersApi: 'api/ri/order/myidm/1.0/idx-group-members',
        serviceAccountValidation: 'api/ri/order/myidm/1.0/check-idx-kafka-group-member',
        ldapMemberValidation: 'api/ri/order/myidm/1.0/check-idx-group-member',
        secondaryAccountDetails: 'api/ri/order/myidm/1.0/secondary-account-details',
        Jwt: {
            createOrder: 'api/day2/1.0/internal/order/adgroup/submit',
            editOrder: 'api/day2/1.0/internal/order/adgroup',
            disableOrder: 'api/day2/1.0/internal/order/disable-group/submit',
            removeMembers: 'api/day2/1.0/internal/order/remove-members/submit',
            bulkGroup: 'api/day2/2.0/internal/order/bulk-group/submit',
            newADGroupMembership: 'api/day2/2.0/internal/order/bulk-group/submit',
        },
    },
    serviceAccountCreation: {
        accountTypes: 'api/static/lookups/1.0/service-account',
        applicationService: 'api/app-registrations/3.0/all-app-profiles',
        environments: 'api/static/lookups/1.0/environments',
        appOwner: 'api/employees/3.0/employee/list',
        sqlServerName: 'api/static/lookups/v2/1.0/sqlserver-details?applicationService',
        sqlServerNameCreate: 'api/static/lookups/v2/1.0/sqlserver-details',
        sectors: 'api/static/lookups/1.0/sectors',
        orderDetails: 'serviceOrderDetails.json',
        myPamSafeList: 'api/ri/resource/name/1.0/my-pam-safe-list',
        Jwt: {
            createOrder: 'api/day2/1.0/internal/order/service-account/submit',
            editOrder: 'api/day2/1.0/internal/order/service-account',
            appShortNameValidation: 'api/ri/resource/name/1.0/app-short-name-service-account/validate',
            generateServiceAcc: 'api/ri/resource/name/1.0/generate/service-account-id',
        },
    },
    onBoardDevelopers: {
        applicationCI: 'api/app-registrations/3.0/all-app-profiles',
        Jwt: {
            submitOrder: 'api/day2/1.0/internal/order/onboarding-developer/submit',
        },
    },
    applicationGateWayURL: {
        environmentDetails: 'api/app-gateway/1.0/properties?isPreview=true', //       //appGateWayurl-envdetails.json
        submitApi: '1.0/appgateway/order/submit', // /ri-submit-order.json
        costCalculation: '/appGatewayURL-costCalculations.json',
        applicationDetails: 'api/cmdb/lookups/1.0/applications/',
        resubmit: '1.0/appgateway/order/resubmit',
        SupportCerts: 'api/static/lookups/v2/1.0/ssl-certificate', //  https://cloud.dev.mypepsico.com/cmp/api/static/lookups/v2/1.0/ssl-certificate
        programApi: 'api/static/lookups/v2/2.0/program',
        validScanRequirementApi: '/appGateUrl-scanRequirement.json',
        isaValidation: '1.0/isa-validation',
        scanValidation: '1.0/scan-validation',
        infosecEnvironment: 'api/static/lookups/1.0/info-sec-environment',
    },
    internalApplicationGateWayURL: {
        environmentDetails: 'api/app-gateway/1.0/properties?isPreview=true&isInternalAppGateway=true', //       //appGateWayurl-envdetails.json
        submitApi: '1.0/internal-appgateway/order/submit',
        resubmitApi: '1.0/internal-appgateway/order/resubmit',
        costCalculation: '/appGatewayURL-costCalculations.json',
        fqdnValidationApi: 'api/static/lookups/1.0/validate-fqdns',
        applicationDetails: 'api/cmdb/lookups/1.0/applications/',
        SupportCerts: 'api/static/lookups/v2/1.0/ssl-certificate', //  https://cloud.dev.mypepsico.com/cmp/api/static/lookups/v2/1.0/ssl-certificate
        programApi: 'api/static/lookups/v2/2.0/program',
        sectors: 'api/static/lookups/v2/1.0/internal/app-gateway/sectors',
    },
    externalPublicLoadBalancerURL: {
        environmentDetails: '/api/load-balancer/1.0/properties?isPreview=true',
        submitApi: '/1.0/public/load-balancer/url-onboard/order/submit',
        costCalculation: '/appGatewayURL-costCalculations.json',
        applicationDetails: 'api/cmdb/lookups/1.0/applications/',
        resubmit: '/1.0/public/load-balancer/url-onboard/order/resubmit',
        SupportCerts: 'api/static/lookups/v2/1.0/ssl-certificate', //  https://cloud.dev.mypepsico.com/cmp/api/static/lookups/v2/1.0/ssl-certificate
        programApi: 'api/static/lookups/v2/2.0/program',
        validScanRequirementApi: '/appGateUrl-scanRequirement.json',
        isaValidation: 'api/order/snow/1.0/isa-number',
        scanValidation: 'api/order/snow/1.0/scan-number',
    },
    internalNewApplicationGateWayProvisioning: {
        environmentDetails: 'api/app-gateway/1.0/internal-app-gateway-details',
        appGWTier: 'api/static/lookups/1.0/internal-appgateway-application-skus',
        vNet: 'api/azure/lookups/vnet/internal-appgateway/location',
        subNet: 'api/azure/lookups/1.0/internal-appgateway/subnets',
        submitApi: '1.0/internal-appgateway/order',
        resubmitApi: '1.0/internal-appgateway/order',
    },
    mdt: {
        applicationCI: 'api/app-registrations/3.0/all-app-profiles',
        appOwner: 'api/employees/3.0/employee/list',
        environment: 'api/static/lookups/1.0/environments',
        sectors: 'api/static/lookups/1.0/sectors',
        Jwt: {
            source: 'api/static/lookups/v2/1.0/source-type',
            sourceValue: 'api/static/lookups/v2/1.0/source-value',
            submitOrder: 'api/day2/1.0/internal/order/mdt/submit',
            sourceNameValidation: 'api/day2/1.0/internal/order/mdt/validate/mdt-filepatterns', // 'mdt-sourceFilenamePattern-success.json',
        },
    },
    virtualService: {
        applicationService: 'api/app-registrations/3.0/all-app-profiles',
        applicationOwner: 'api/employees/3.0/employee/list',
        sector: 'api/static/lookups/v2/1.0/sectors',
        environment: 'api/static/lookups/v2/1.0/environments',
        appRegions: 'api/static/lookups/v2/1.0/regions',
        regions: 'api/azure/lookups/locations',
        program: 'api/static/lookups/v2/1.0/program',
        cluster: 'api/static/lookups/v2/1.0/internal/aks-cluster',
        costDetails: 'api/services/virtual-service/1.0/cost-calculation',
        orderDetails: '/orders',
        submitOrder: 'api/services/virtual-service/orders',
        validationStatus: 'api/services/orders/{orderId}/validation-status',
        namespaceValidate: 'api/services/virtual-service/1.0/aks/namespace/validate',
        inventorynameSapceValidate: 'api/inventory/report/1.0/inventory-report',
        costCenter: 'api/cmdb/lookups/1.0/projects',
        certificateValidation: 'api/services/virtual-service/1.0/certificate/details',
        orderDetails1: 'virtual-service/order-details.json',
        departments: 'api/eip/lookups/1.0/catalog-departments/AKS',
        istioGtWayUrl: 'api/static/lookups/1.0/aks-properties',
        costCenterValidation: 'api/order/snow/1.0/budget-code',
        validateServiceAccount: 'api/services/virtual-service/validate-details',
        aksKeyvaultDetails: (aksName) => `api/static/lookups/v2/1.0/aks-keyvault-details/${aksName}`,
        Jwt: {
            allowedMethods: 'api/services/virtual-service/cors/1.0/allowed-methods',
            allowedHeaders: 'api/services/virtual-service/cors/1.0/allowed-headers',
            exposeHeaders: 'api/services/virtual-service/cors/1.0/expose-headers',
            restrictedPorts: 'api/services/virtual-service/1.0/restricted-ports',
            vsOnboardTypes: 'api/services/virtual-service/1.0/onboard-types',
        },
    },
    devX: {
        prepolulateTools: `${process.env.REACT_APP_DEVX_BASE_URL}cgf/devx-launchpad-service/v1/journeys/{journeyId}/tools/prepopulate`,
        prepolulateInfra: `${process.env.REACT_APP_DEVX_BASE_URL}cgf/devx-launchpad-service/v1/journeys/{journeyId}/infra/prepopulate`,
        submitTools: `${process.env.REACT_APP_DEVX_BASE_URL}cgf/devx-launchpad-service/v1/journeys/{journeyId}/workflow/toolsOnboardingInputs`,
        submitInfra: `${process.env.REACT_APP_DEVX_BASE_URL}cgf/devx-launchpad-service/v1/journeys/{journeyId}/workflow/infraOnboardingInputs`,
    },
    staticLookups: {
        autoApprovalRule: 'api/static/lookups/1.0/auto-approval-rule',
        autoApprovalRules: 'api/static/lookups/1.0/auto-approval-rules',
        delegates: 'api/static/lookups/1.0/delegates',
        deleteDelegate: ({ delegateID, scheduleId }) => `api/static/lookups/1.0/delegates?delegateId=${delegateID}&scheduleId=${scheduleId}`,
    },
    postgreSql: {
        versions: 'api/static/lookups/1.0/postgresql-versions',
        flexibleServerName: 'api/ri/resource/name/2.0/resource-name',
        skuName: (payload) => `api/azure/lookups/1.0/postgresql-sizes/location/${payload.location}/subscription/${payload.subscription}`,
        databaseCharset: 'api/static/lookups/1.0/postgresql-charset-collations',
        resourceGroup: ({ location, rgName }) => `api/azure/lookups/1.0/location/${location}/resource-group/${rgName}/subscription`,
        postgreSqlSizes: 'api/azure/lookups/1.0/postgresql-sizes/filter',
    },
    mySql: {
        versions: 'api/static/lookups/1.0/mysql-flexi-versions',
        flexibleServerName: 'api/ri/resource/name/2.0/resource-name',
        databaseCharset: 'api/static/lookups/1.0/mysql-charset-collations',
        resourceGroup: ({ location, rgName }) => `api/azure/lookups/1.0/location/${location}/resource-group/${rgName}/subscription`,
        mySqlSizes: 'api/azure/lookups/1.0/azure-sql-skus',
        mySqlStorageSizes: 'api/static/lookups/1.0/mysql-storage-sizes',
    },
    oracleExadata: {
        infrastructures: (environment, region) => `api/static/lookups/1.0/oracle-exadata-infrastructures?environment=${environment}&region=${region}`,
        vmClusterDetails: (environment, region, exadataInfrastructure) =>
            `api/static/lookups/1.0/oracle-exadata-vm-cluster-details?environment=${environment}&region=${encodeURIComponent(
                region
            )}&exadataInfrastructure=${exadataInfrastructure}`,
        databaseVersions: 'api/static/lookups/1.0/oracle-exadata-database-versions',
    },
    announcements: {
        list: 'api/static/lookups/1.0/announcements',
        create: 'api/static/lookups/1.0/announcements',
        active: `api/static/lookups/1.0/announcements/active`,
        get: (id) => `api/static/lookups/1.0/announcements/${id}`,
        update: (id) => `api/static/lookups/1.0/announcements/${id}`,
        delete: (id) => `api/static/lookups/1.0/announcements/${id}`,
    },
    cosmosDb: {
        apiTypes: 'api/static/lookups/1.0/cosmos-api-types',
        databaseName: 'api/ri/resource/name/1.0/resource-name',
        mongoResourceType: 'api/static/lookups/1.0/mongodb-api-types',
        mongoDbVersions: 'api/static/lookups/1.0/mongodb-versions',
        clusterTier: 'api/static/lookups/1.0/mongodb-cluster-tiers',
        clusterSize: ({ environment }) => `api/static/lookups/1.0/mongodb-cluster-tiers/${environment}`,
        nodeCount: 'api/static/lookups/1.0/postgresql-node-configs',
        postgresVersions: 'api/static/lookups/1.0/postgresql-versions',
    },
    edapNodePool: {
        taints: 'api/ri/resource/name/1.0/resource-name',
        osSkus: (osType) => `api/static/lookups/aws/1.0/os-skus?osType=${encodeURIComponent(osType)}`,
    },
};

export const routerLinks = {};
